export const DROPIN_START = 'DROPIN_START';
export const DROPIN_END = 'DROPIN_END';
export const SET_ENABLE_ALL_FEATURES = 'SET_ENABLE_ALL_FEATURES';

export const startDropin = (seller) => ({
  type: DROPIN_START,
  seller,
});

export const endDropin = (reload = true) => ({
  type: DROPIN_END,
  reload,
});

export const setEnableAllFeatures = (isEnabled) => ({
  type: SET_ENABLE_ALL_FEATURES,
  isEnabled,
});
